import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

import { TicketDetail } from '../types'
import { ticketsQueryKey } from './useTickets'

export function useTicketDetail(id?: string) {
  async function getTicket() {
    const res = await apiClient.get<TicketDetail>(`${SNA_PREFIX}tickets/${id}/`)
    return res.data
  }

  return useQuery({
    queryFn: getTicket,
    queryKey: [...ticketsQueryKey, id],
    enabled: !!id
  })
}
